import { render, staticRenderFns } from "./stuApply.vue?vue&type=template&id=f6444dba&scoped=true&"
import script from "./stuApply.vue?vue&type=script&lang=js&"
export * from "./stuApply.vue?vue&type=script&lang=js&"
import style0 from "./stuApply.vue?vue&type=style&index=0&id=f6444dba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6444dba",
  null
  
)

export default component.exports